import React, { Component } from "react";
import { Modal } from "react-bootstrap";

class TutoringWorthModal extends Component {

    constructor() {
        super();

        this.state = {
            offlineOptionArray: [
                "I don't have enough time to tutor",
                "I am not earning enough from tutoring",
                "It takes too much time or money to prepare my lessons",
                "It takes too much time to manage upcoming lessons",
                "I have other reasons",
            ]
        }

    }

    render() {

        const {
            isOpen,
            onHide,
            goBack,
            disable,
            nextButton,
            selectReason,
            offlineDetails,
        } = this.props;

        const { offlineOptionArray } = this.state;
    
        return (

            <Modal
                centered
                size="lg"
                show={isOpen}
                onHide={onHide}
                className="profile-status-modal"
            >
                <Modal.Header>
                    <button onClick={onHide} data-dismiss="modal" aria-label="Close" className="close">
                        <i className="mdi mdi-close"></i>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <h4>Tutoring isn't worth time and money</h4>
                    <p>Sharing more details can help us improve tutor experience.</p>
                    <div className="green-radio-custom">
                        {offlineOptionArray.length
                            ? offlineOptionArray.map((question, i) => (
                                <div key={i} className="custom-control custom-radio">
                                    <input
                                        type="radio"
                                        name={`customRadioInline0`}
                                        className="custom-control-input"
                                        id={`customRadioInline${question}`}
                                        defaultChecked={offlineDetails.reasonForLeaving === question}
                                    />
                                    <label
                                        className="custom-control-label"
                                        onClick={() => selectReason(question)}
                                        htmlFor={`customRadioInline${question}`}
                                    >
                                        {question}
                                    </label>
                                </div>
                            )) : ""
                        }
                    </div>
                    <div className="buttons">
                        <button className="back" onClick={goBack}>
                            <i className="fa fa-angle-left"></i>Back
                        </button>
                        <button onClick={nextButton} disabled={disable} className="button">Next</button>
                    </div>
                </Modal.Body>
            </Modal>

        );

    }

}

export default TutoringWorthModal;